import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useBoard} from '@containers/hooks'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub, TimerStickerValue} from 'yougile-model'
import {getColumns, getColumnsTimeSum} from './stopwatch-column-utils'

const TwContainer = tw.div`
  flex
  flex-col
  gap-8
  text-main-old
  text-11
`

const TwTitle = tw.div`
  font-semibold
  leading-main
`

const TwColumns = tw.div`
  flex
  flex-col
  gap-8
  leading-4
`

const TwRow = tw.div`
  flex
  justify-between
`

interface Props {
  task: Hub
  timerStickerValue: TimerStickerValue
}

const StraightLine = () => (
  <div
    className="h-1 my-8"
    style={{
      background: `repeating-linear-gradient(to right, #D9D9D9 0, #D9D9D9 3px, transparent 3px)`
    }}
  />
)

export const StopwatchColumnContent = ({task, timerStickerValue}: Props) => {
  return (
    <>
      <StraightLine />
      <StopwatchColumnContentBase
        task={task}
        timerStickerValue={timerStickerValue}
        title={Lang.msg.myStickers.workingHoursInColumns}
      />
    </>
  )
}

interface PropsBase {
  task: Hub
  timerStickerValue: TimerStickerValue
  title: string
}
export const StopwatchColumnContentBase = (props: PropsBase) => {
  const {task, timerStickerValue, title} = props
  const board = useBoard()
  const columns = getColumns(board, task, timerStickerValue)
  const sum = columns.length > 1 && getColumnsTimeSum(columns)

  return (
    <>
      <TwContainer>
        <TwTitle>{title}</TwTitle>
        <TwColumns>
          <WithPerfectScrollbar className="-mr-8">
            <div className="pr-8 max-h-96">
              {columns?.map(col => {
                return (
                  <TwRow key={col.column.id}>
                    <div className="truncate max-w-194 pr-4">
                      {col.column.title}
                    </div>
                    <div className="whitespace-nowrap">{col.time}</div>
                  </TwRow>
                )
              })}
            </div>
          </WithPerfectScrollbar>
          {sum && (
            <TwRow>
              <div>{Lang.msg.myStickers.sum}</div>
              <div>{sum}</div>
            </TwRow>
          )}
        </TwColumns>
      </TwContainer>
    </>
  )
}
